<template>

  <div>
    <div class="va-row">
      <div class="flex md12 xs12">

        <div class="form-group">
          <div class="input-group">

            <slot></slot>
            <vuestic-checkbox
              :name="name"
              v-model="isChecked"
              @input="onChangeInternal"/>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'checkbox-cell',

  data: function () {
    return {
      isChecked: this.initialValue
    }
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },

    initialValue: {
      type: Boolean
    },

    name: {
      type: String
    },

    onChange: {
      type: Function,
      default: () => {
      }
    }
  },

  mounted: function () {
  },

  methods: {
    onChangeInternal: function () {
      this.onChange({
        value: this.isChecked ? 1 : 0,
        name: this.name,
        type: 'checkbox',
        id: this.rowData.id
      })
    }
  }
}

</script>

<style scoped>

</style>
